// Keep in sync with ASI archive-to-CODE_FILE mappings in asset_type_mapping.py.
const BINARY_DOWNLOAD_EXTENSIONS = ['.tar', '.tar.bz2', '.tar.gz', '.tar.xz', '.tgz', '.zip'];
const BINARY_DOWNLOAD_MIME_TYPES = new Set([
    'application/gzip',
    'application/x-gzip',
    'application/x-tar',
    'application/x-zip-compressed',
    'application/zip',
]);
function normalizeFilename(filename) {
    const normalizedFilename = filename?.trim().split(/[?#]/, 1)[0]?.split(/[\\/]/).pop();
    return normalizedFilename || null;
}
function getFilenameExtension(filename) {
    const normalizedFilename = normalizeFilename(filename);
    const dotIndex = normalizedFilename?.lastIndexOf('.') ?? -1;
    if (!normalizedFilename || dotIndex < 0 || dotIndex === normalizedFilename.length - 1) {
        return null;
    }
    return normalizedFilename.slice(dotIndex + 1).toLowerCase();
}
export function getTextPreviewFilename(...filenameCandidates) {
    const candidates = filenameCandidates
        .map((filename) => filename?.trim())
        .filter((filename) => Boolean(filename));
    return (candidates.find((filename) => getFilenameExtension(filename) != null) ?? candidates[0] ?? null);
}
export function isBinaryDownloadFile({ filename, mimeType, }) {
    const normalizedFilename = normalizeFilename(filename)?.toLowerCase() ?? '';
    const normalizedMimeType = mimeType?.trim().toLowerCase() ?? '';
    return (BINARY_DOWNLOAD_MIME_TYPES.has(normalizedMimeType) ||
        BINARY_DOWNLOAD_EXTENSIONS.some((extension) => normalizedFilename.endsWith(extension)));
}
//# sourceMappingURL=filePreviewUtils.js.map